export default __webpack_public_path__ + "static/Asphalt-Parking-Lot-Removal-be377a90f72a66d608c4fee7988c512d.jpg";